export const SplashScreen = 'atlantis-splash-screen';